import { FETCH_USER_SUMMARY_REQUEST, FETCH_USER_SUMMARY_SUCCESS, FETCH_USER_SUMMARY_ERROR } from '../constants/ActionTypes'
import type { ResponseError } from '@ynap/api-utils'
import type GenericAction from './types/genericAction.types'
import { UserSummary } from 'app/types/userSummary.types'

const initialState: State = {
    user: {},
    isLoading: false,
    error: undefined,
}

type State = {
    user: UserSummary | ResponseError
    isLoading?: boolean
    error?: ResponseError
}

export type UserSummaryAction = GenericAction<
    typeof FETCH_USER_SUMMARY_REQUEST | typeof FETCH_USER_SUMMARY_SUCCESS | typeof FETCH_USER_SUMMARY_ERROR,
    { payload?: UserSummary | ResponseError }
>

const userSummaryReducer = (state: State = initialState, action: UserSummaryAction): State => {
    switch (action.type) {
        case FETCH_USER_SUMMARY_REQUEST:
            return { ...state, isLoading: true }

        case FETCH_USER_SUMMARY_SUCCESS:
            return { 
                user: action.payload || {}, 
                isLoading: false 
            }

        case FETCH_USER_SUMMARY_ERROR:
            return { 
                ...state, 
                error: action.payload, 
                isLoading: false 
            }

        default:
            return state
    }
}

export default userSummaryReducer
